import { useQuery, UseQueryOptions } from "react-query";

import { mapAchFeeTemplateDataFromServer } from "mappers";
import { feeTemplateService } from "services";

type UseGetAchFeeTemplateQueryProps = {
	companyId: string;
	templateId: string;
	options?:
		| Omit<
				UseQueryOptions<any, unknown, any, string[]>,
				"queryKey" | "queryFn"
		  >
		| undefined;
};

const useGetAchFeeTemplateQuery = ({
	companyId,
	templateId,
	options,
}: UseGetAchFeeTemplateQueryProps) => {
	return useQuery(
		["getAchFeeTemplate", companyId, templateId],
		() => feeTemplateService.achFeeTemplateGet({ companyId, templateId }),
		{
			select: data => mapAchFeeTemplateDataFromServer(data),
			enabled: !!companyId && !!templateId,
			...options,
		},
	);
};

export default useGetAchFeeTemplateQuery;
